module.exports = __webpack_public_path__ + "static/media/object@3x.4e863b48.png";